/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  BalancerV2Swap,
  BalancerV2SwapInterface,
} from "../BalancerV2Swap";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_balancerVault",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_oracle",
        type: "address",
      },
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "resolvePoolId",
    outputs: [
      {
        internalType: "bytes32",
        name: "poolId",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "spenderToApprove",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenIn",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_siloOracle",
        type: "address",
      },
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
    ],
    name: "swapAmountIn",
    outputs: [
      {
        internalType: "uint256",
        name: "amountOut",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenIn",
        type: "address",
      },
      {
        internalType: "address",
        name: "_tokenOut",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amountOut",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "_siloOracle",
        type: "address",
      },
      {
        internalType: "address",
        name: "_siloAsset",
        type: "address",
      },
    ],
    name: "swapAmountOut",
    outputs: [
      {
        internalType: "uint256",
        name: "amountIn",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "vault",
    outputs: [
      {
        internalType: "contract IVault",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type BalancerV2SwapConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: BalancerV2SwapConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class BalancerV2Swap__factory extends ContractFactory {
  constructor(...args: BalancerV2SwapConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "BalancerV2Swap";
  }

  deploy(
    _balancerVault: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<BalancerV2Swap> {
    return super.deploy(
      _balancerVault,
      overrides || {}
    ) as Promise<BalancerV2Swap>;
  }
  getDeployTransaction(
    _balancerVault: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(_balancerVault, overrides || {});
  }
  attach(address: string): BalancerV2Swap {
    return super.attach(address) as BalancerV2Swap;
  }
  connect(signer: Signer): BalancerV2Swap__factory {
    return super.connect(signer) as BalancerV2Swap__factory;
  }
  static readonly contractName: "BalancerV2Swap";
  public readonly contractName: "BalancerV2Swap";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): BalancerV2SwapInterface {
    return new utils.Interface(_abi) as BalancerV2SwapInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): BalancerV2Swap {
    return new Contract(address, _abi, signerOrProvider) as BalancerV2Swap;
  }
}
